<template>
  <ul class="mt-4 flex items-center justify-between">
    <template v-for="item in links">
      <li
        :key="item.text"
        v-if="!item.hideInDesktop"
        class="text-b78 relative text-sm xl:text-base z-[10]"
        @mouseenter="setActiveMenu(item)"
        @mouseleave="activeMenu = ''">
        <component
          :is="item.link ? 'a' : 'span'"
          :href="item.link"
          :target="item.openInNewTab ? '_blank' : '_self'"
          :class="[
            'hover:text-white border-b py-3 flex items-center font-semibold',
            [activeMenu, selectedMenuText].includes(item.text)
              ? 'text-white border-whitem           '
              : 'border-transparent',
          ]"
          @click="trackClickEvents(item.text, item.link)">
          <img v-if="item.icon" :src="`/assets/images/shared/${item.icon}.png`" class="mr-[6px]" />
          {{ item.text }}
          <div
            v-if="item.isNew"
            class="ml-2 rounded bg-primary-offwhite px-[4px] py-[2px] text-[10px] font-bold text-primary-purple">
            NEW
          </div>
          <i
            v-if="item.children && item.children.length > 0"
            :class="[
              'fa-regular text-xs ml-[6px]',
              activeMenu === item.text ? 'fa-chevron-up' : 'fa-chevron-down',
            ]"></i>
        </component>
        <div
          v-if="item.children && item.children.length > 0"
          :class="[
            'absolute top-0 w-56 z-10',
            activeMenu === item.text ? 'block' : 'hidden',
            item.text === 'Tools' ? 'right-0' : 'left-0',
          ]">
          <ul class="bg-p5 py-[10px] rounded-md submenu-box-shadow mt-[60px]">
            <li v-for="subItem in item.children" class="leading-normal" :key="subItem.link">
              <a
                :href="subItem.link"
                @click="subCategoryClick(subItem.text, subItem.link)"
                class="px-5 py-[10px] flex items-center text-primary-offwhite space-x-3 hover:bg-white hover:bg-opacity-5"
                :class="{ 'bg-white bg-opacity-5': selectedSubMenuText === subItem.text }">
                {{ subItem.text }}
              </a>
            </li>
          </ul>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';

export default {
  inject: [
    'links', // Provided by components/NavMenu/index.vue
  ],
  data() {
    return {
      activeMenu: '',
    };
  },
  computed: {
    selectedMenuText() {
      return this.selectedMenu?.text;
    },
    selectedMenu() {
      const path = this.$route.path;
      const selectedMenu = Object.values(this.links).find(item => {
        if (item.link === path) {
          return true;
        }

        return (item.children || []).some(subItem => subItem.link === path);
      });
      return selectedMenu;
    },
    selectedSubMenuText() {
      const path = this.$route.path;
      const selectedSubMenu = (this.selectedMenu?.children || []).find(item => item.link === path);
      return selectedSubMenu?.text;
    },
  },
  methods: {
    subCategoryClick(name, link) {
      eventTracker(analyticsEvents.clickOnSubcategory, {
        subCategorytext: name,
        clickSource: 'topMenu',
      });
      this.trackNavigationClickEvent(name, link);
    },
    trackNavigationClickEvent(clickText, clickUrl) {
      const eventData = {
        type: 'header',
        clickText,
        clickUrl,
      };
      eventTracker(analyticsEvents.navigationClick, eventData);
      dataLayerTrack({ eventtext: gtmEvents.navigationClick, data: eventData });
    },
    setActiveMenu(item) {
      this.activeMenu = item.text;
      if (item.children?.length > 0) {
        this.trackClickOnCategoryEvent(item.text);
        this.$emit('active');
      }
    },
    trackClickOnCategoryEvent(category) {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: category,
        clickSource: 'topMenu',
      });
    },
    trackClickEvents(name, link) {
      this.trackClickOnCategoryEvent(name);
      if (link) {
        this.trackNavigationClickEvent(name, link);
      }
    },
  },
};
</script>

<style scoped>
.submenu-box-shadow {
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.3);
}
.py-\[10px\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.ml-\[6px\] {
  margin-left: 6px;
}
.border-b-\[3px\] {
  border-bottom-width: 3px;
}
.mt-\[7px\] {
  margin-top: 7px;
}
.mr-\[6px\] {
  margin-right: 6px;
}
.mt-\[60px\] {
  margin-top: 60px;
}
.text-\[10px\] {
  font-size: 10px;
}
.py-\[2px\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.px-\[4px\] {
  padding-right: 4px;
  padding-left: 4px;
}
</style>
